import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function CareHighlights() {
  return <section className="bg-white overflow-hidden" data-id="element-17">
      {/* Top Row: Text | Image | Testimonial */}
      <div className="grid lg:grid-cols-3" data-id="element-18">
        {/* Left - Text Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col justify-center px-8 md:px-12 lg:px-16 py-16 lg:py-20" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-chocolate leading-tight mb-6" data-id="element-20">
            Affordable care for those who need it most.
          </h2>
          <p className="text-chocolate/80 leading-relaxed mb-4" data-id="element-21">
            Our services are designed to be accessible to everyone. We work with
            a range of insurance providers and offer flexible payment options so
            that all of your healthcare needs are covered without unexpected
            costs.
          </p>
          <p className="text-chocolate/80 leading-relaxed mb-8" data-id="element-22">
            If you have concerns about financial eligibility, our care
            coordinators can assist with qualifying for our health plans with
            ease. You or your loved one can get the support you deserve.
          </p>
          <div data-id="element-23">
            <Link to="/contact" className="inline-flex items-center bg-chocolate text-cream px-8 py-4 font-medium hover:bg-gold hover:text-white transition-colors duration-300 shadow-md" data-id="element-24">
              Send Us A Message
            </Link>
          </div>
        </motion.div>

        {/* Center - Image */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="relative min-h-[350px] lg:min-h-0" data-id="element-25">
          <img src="https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?auto=format&fit=crop&q=80&w=1200" alt="A caregiver warmly embracing an elderly patient" className="w-full h-full object-cover" data-id="element-26" />
        </motion.div>

        {/* Right - Testimonial */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col justify-center px-8 md:px-12 lg:px-16 py-16 lg:py-20 bg-nude-light" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-chocolate leading-tight mb-6" data-id="element-28">
            Top notch healthcare.
          </h2>
          <p className="text-chocolate/80 leading-relaxed mb-10 italic" data-id="element-29">
            "Crownehealth has provided me with security and top-notch
            healthcare. I have never been at such peace of mind to know that
            whatever I need, I can count on my team."
          </p>
          <div data-id="element-30">
            <div className="text-chocolate/70 text-sm font-medium" data-id="element-31">
              Richard Johnson
            </div>
            <div className="text-chocolate/50 text-sm" data-id="element-32">
              Crownehealth Patient Since July 2023
            </div>
          </div>
        </motion.div>
      </div>

      {/* Bottom Row: Image | Text */}
      <div className="grid lg:grid-cols-2" data-id="element-33">
        {/* Left - Image (bleeds to left edge) */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative min-h-[350px] lg:min-h-[500px] bg-chocolate-dark" data-id="element-34">
          <img src="https://images.unsplash.com/photo-1582750433449-648ed127bb54?auto=format&fit=crop&q=80&w=1400" alt="A doctor consulting with an elderly patient" className="w-full h-full object-cover" data-id="element-35" />
        </motion.div>

        {/* Right - Text Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="flex flex-col justify-center px-8 md:px-12 lg:px-20 py-16 lg:py-20" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-chocolate leading-tight mb-6" data-id="element-37">
            A different kind of care.
          </h2>
          <p className="text-chocolate/80 leading-relaxed mb-4" data-id="element-38">
            With Crownehealth, your aging loved ones can enjoy the benefits of a
            dedicated care center, where they can engage in a wide array of
            activities, receive educational resources, and become part of a
            vibrant community. We prioritize their well-being, providing the
            supervision, companionship, and interaction they desire and need.
          </p>
          <p className="text-chocolate/80 leading-relaxed" data-id="element-39">
            Experience peace of mind knowing that your loved ones are receiving
            the best possible care. Embrace this transformative solution and
            ensure a fulfilling and secure future for your aging family members.
          </p>
        </motion.div>
      </div>
    </section>;
}